<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        persistent
        scrollable
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            Confirmación de Carga
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form-validation-upload"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      id="cantidad_filas"
                      :value="dataFile.cantidad_filas"
                      label="Cantidad de Filas"
                      readonly
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      :rules="[rules.confirmField('cantidad_filas')]"
                      label="Confirmar Cantidad de Filas"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  v-for="(file, idx) in dataFile.criterios_validacion"
                  :key="idx"
                >
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      :id="file.validationName"
                      :value="formatNumber(file.value)"
                      :label="file.validationName"
                      readonly
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      :rules="[rules.confirmField(file.validationName)]"
                      :label="`Confirmar ${file.validationName}`"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              @click="closeDialog"
              outlined
              :disabled="loadingButton"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="blue darken-1"
              @click="confirmDialog"
              outlined
              :disabled="loadingButton"
              :loading="loadingButton"
              :style="{'width' : loadingButton ? '160px' : ''}"
            >
              Cargar
              <template v-slot:loader>
                <span>Cargando</span>
                <v-progress-circular
                  indeterminate
                  size="16"
                  color="primary"
                  class="ml-1"
                ></v-progress-circular>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import eventBus from '../../../utils/eventBus'

export default {
  name: 'validation-dialog-confirmation',
  data () {
    return {
      loadingButton: false,
      rules: {
        confirmField (field) {
          return v => (document.querySelector(`#${field}`) ? document.querySelector(`#${field}`).value === v : false) || `No coincide con ${field}`
        }
      }
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default () {
        return false
      }
    },
    dataFile: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    formatNumber (value) {
      return Math.abs(value).toFixed(2)
    },
    closeDialog () {
      this.$refs['form-validation-upload'].reset()
      this.$emit('update:showDialog', false)
    },
    confirmDialog () {
      if (this.$refs['form-validation-upload'].validate()) {
        this.loadingButton = true
        axios.post(uris.URL_AUTOSERVICIO_INSERT_DATA,
          {
            processID: this.dataFile.processID,
            asLogId: this.dataFile.asLogId
          }
        )
          .then((response) => {
            this.$refs['form-validation-upload'].reset()
            eventBus.$emit('open-custom-snack-bar', {message: 'Archivo Cargado', itsOk: true})
            eventBus.$emit('show-button-mydata', { isDisabled: false, asLogId: this.dataFile.asLogId })
            this.$emit('update:showDialog', false)
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.errors) {
              eventBus.$emit('open-dialog-insert-data-error', {
                showDialog: true,
                errors: err.response.data
              })
            }
            eventBus.$emit('open-custom-snack-bar', {message: err.response.data.error, itsOk: 'warning'})
            console.warn('No se pudo cargar el archivo', err)
          })
          .finally(() => {
            this.loadingButton = false
          })
      }
    }
  }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-dialog-confirmation.vue